<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg4 xs4>
                        <v-text-field
                          v-model="filter.accmType"
                          :label="label.accmType"
                          :error-messages="errors.collect('filter.accmType')"
                          data-vv-name="filter.accmType"
                          :data-vv-as="label.accmType"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs4>
                        <v-text-field
                          v-model="filter.treatyNo"
                          :label="label.treatyNo"
                          :error-messages="errors.collect('filter.treatyNo')"
                          data-vv-name="filter.treatyNo"
                          :data-vv-as="label.treatyNo"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs4>
                        <v-text-field
                          v-model="filter.riType"
                          :label="label.riType"
                          :error-messages="errors.collect('filter.riType')"
                          data-vv-name="filter.riType"
                          :data-vv-as="label.riType"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs4>
                        <cal-picker v-model="filter.effDate" :label="label.effDate" :data-vv-as="label.effDate" data-vv-name="effDate"></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg4 xs4>
                        <v-text-field
                          v-model="filter.tretyLvl"
                          :label="label.tretyLvl"
                          :error-messages="errors.collect('filter.tretyLvl')"
                          data-vv-name="filter.tretyLvl"
                          :data-vv-as="label.tretyLvl"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs4>
                        <v-text-field
                          v-model="filter.facVal1"
                          :label="label.facVal1"
                          :error-messages="errors.collect('filter.facVal1')"
                          data-vv-name="filter.facVal1"
                          :data-vv-as="label.facVal1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs4>
                        <v-text-field
                          v-model="filter.facVal2"
                          :label="label.facVal2"
                          :error-messages="errors.collect('filter.facVal2')"
                          data-vv-name="filter.facVal2"
                          :data-vv-as="label.facVal2"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs4>
                        <v-text-field
                          v-model="filter.facVal3"
                          :label="label.facVal3"
                          :error-messages="errors.collect('filter.facVal3')"
                          data-vv-name="filter.facVal3"
                          :data-vv-as="label.facVal3"
                        ></v-text-field>
                      </v-flex>
                      <!-- <v-flex xl3 lg4 xs4>
                      <v-text-field v-model="filter.facVal4" :label="label.facVal4" :error-messages="errors.collect('filter.facVal4')" data-vv-name="filter.facVal4" :data-vv-as="label.facVal4"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs4>
                      <v-text-field v-model="filter.facVal5" :label="label.facVal5" :error-messages="errors.collect('filter.facVal5')" data-vv-name="filter.facVal5" :data-vv-as="label.facVal5"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs4>
                      <v-text-field v-model="filter.facVal6" :label="label.facVal6" :error-messages="errors.collect('filter.facVal6')" data-vv-name="filter.facVal6" :data-vv-as="label.facVal6"></v-text-field>
                    </v-flex> -->
                      <v-flex xl3 lg4 xs4>
                        <v-text-field
                          v-model="filter.treatyLimit"
                          :label="label.treatyLimit"
                          :error-messages="errors.collect('filter.treatyLimit')"
                          data-vv-name="filter.treatyLimit"
                          :data-vv-as="label.treatyLimit"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark class=" mr-2" @click="doNew">
                    New treaty Limit
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      v-bind:options.sync="pagination"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td class="text-xs-left">{{ row.item.accmType }}</td>
                          <td class="text-xs-left">{{ row.item.treatyNo }}</td>
                          <td class="text-xs-left">{{ row.item.riType }}</td>
                          <td class="text-xs-left">{{ convertDate(new Date(row.item.effDate)) }}</td>
                          <td class="text-xs-left">{{ row.item.treatyLvl }}</td>
                          <td class="text-xs-left">{{ row.item.facVal1 }}</td>
                          <td class="text-xs-left">{{ row.item.facVal2 }}</td>
                          <td class="text-xs-left">{{ row.item.facVal3 }}</td>
                          <!-- <td class="text-xs-left">{{ row.item.facVal4 }}</td>
                        <td class="text-xs-left">{{ row.item.facVal5 }}</td>
                        <td class="text-xs-left">{{ row.item.facVal6 }}</td> -->
                          <td class="text-right">{{ formatDisplayNumber(row.item.treatyLimit, 2) }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              query
                              @query="doQuery(row.item)"
                              review
                              @review="doReview(row.item)"
                              remove
                              @remove="doPromptRemove(row.item)"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-card>
    </v-flex>
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>Are you sure you want to delete the selected Treaty Limit?</p>
      <div class="queryValue">
        Accumulation Type: {{ selectedTreatyLimit.accmType }}<br />
        Treaty No: {{ selectedTreatyLimit.treatyNo }}<br />
        RI Type: {{ selectedTreatyLimit.riType }}<br />
        Effective Date: {{ convertDate(new Date(selectedTreatyLimit.effDate)) }}<br />
        Treaty Level: {{ selectedTreatyLimit.treatyLvl }}<br />
        Factor 1 Value: {{ selectedTreatyLimit.facVal1 }}<br />
        Factor 2 Value: {{ selectedTreatyLimit.facVal2 }}<br />
        Factor 3 Value: {{ selectedTreatyLimit.facVal3 }}<br />
        <!-- Factor 4 Value: {{selectedTreatyLimit.facVal4}}<br/>
        Factor 5 Value: {{selectedTreatyLimit.facVal5}}<br/>
        Factor 6 Value: {{selectedTreatyLimit.facVal6}}<br/> -->
        Treaty Limit: {{ selectedTreatyLimit.limType }}<br />
        Account Suffix: {{ selectedTreatyLimit.accountNoSuffix }}<br />
      </div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      promptRemove: false,
      label: {
        accmType: 'Accumulation Type',
        treatyNo: 'Treaty No.',
        riType: 'RI Type',
        effDate: 'Effective Date',
        tretyLvl: 'Treaty Level',
        facVal1: 'Factor 1',
        facVal2: 'Factor 2',
        facVal3: 'Factor 3',
        facVal4: 'Factor 4',
        facVal5: 'Factor 5',
        facVal6: 'Factor 6',
        treatyLimit: 'Treaty Limit'
      },
      filter: {
        accmType: null,
        treatyNo: null,
        riType: null,
        effDate: null,
        tretyLvl: null,
        facVal1: null,
        facVal2: null,
        facVal3: null,
        facVal4: null,
        facVal5: null,
        facVal6: null,
        treatyLimit: null
      },
      items: [],
      totalItems: 0,
      loading: false,
      headers: [
        { text: 'Accum. Type', value: 'accmType' },
        { text: 'Treaty No.', value: 'treatyNo' },
        { text: 'RI Type', value: 'riType' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Level', value: 'treatyLvl' },
        { text: 'Factor 1', value: 'facVal1' },
        { text: 'Factor 2', value: 'facVal2' },
        { text: 'Factor 3', value: 'facVal3' },
        // { text: 'Factor 4', value: 'facVal4' },
        // { text: 'Factor 5', value: 'facVal5' },
        // { text: 'Factor 6', value: 'facVal6' },
        { text: 'Limit', value: 'treatyLimit' },
        TableConst.tableActionHeader
      ],
      selectedTreatyLimit: {
        accmType: null,
        treatyNo: null,
        riType: null,
        effDate: null,
        treatyLvl: null,
        facVal1: null,
        facVal2: null,
        facVal3: null,
        facVal4: null,
        facVal5: null,
        facVal6: null,
        limType: null,
        accountNoSuffix: null
      },
      treatyMode: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      this.fetchData(false)
    },
    doClearFilters() {
      this.filter.accmType = null
      this.filter.treatyNo = null
      this.filter.riType = null
      this.filter.effDate = null
      this.filter.tretyLvl = null
      this.filter.facVal1 = null
      this.filter.facVal2 = null
      this.filter.facVal3 = null
      this.filter.facVal4 = null
      this.filter.facVal5 = null
      this.filter.facVal6 = null
      this.filter.treatyLimit = null
      this.fetchData(false)
    },
    doFilters() {
      this.fetchData(false)
    },
    formatDisplayNumber(val, dec) {
      return formatDisplayNumber(val, dec)
    },
    doNew() {
      const commit = {
        treatyMode: 'New',
        accmType: null,
        treatyNo: null,
        riType: null,
        effDate: null,
        treatyLvl: null,
        facVal1: null,
        facVal2: null,
        facVal3: null,
        facVal4: null,
        facVal5: null,
        facVal6: null,
        limType: null,
        accountNoSuffix: null
      }
      sessionStorage.setItem('ttyLim', JSON.stringify(commit))
      this.$store.commit('TREATYLIMIT_COMMIT_KEY', commit)
      this.$router.push({ name: 'treatyLimitDetail' })
    },
    async fetchData(options) {
      const apiURI = this.menu.treatyLimitList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let messageFilters = clone(this.filter)
          if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
            messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((treatyLimit) => {
                const convertList = {
                  accmType: treatyLimit.accmType,
                  treatyNo: treatyLimit.treatyNo,
                  riType: treatyLimit.riType,
                  effDate: treatyLimit.effDate,
                  treatyLvl: treatyLimit.treatyLvl,
                  facVal1: treatyLimit.facVal1,
                  facVal2: treatyLimit.facVal2,
                  facVal3: treatyLimit.facVal3,
                  facVal4: treatyLimit.facVal4,
                  facVal5: treatyLimit.facVal5,
                  facVal6: treatyLimit.facVal6,
                  treatyLimit: treatyLimit.treatyLimit,
                  limType: treatyLimit.limType,
                  accountNoSuffix: treatyLimit.accountNoSuffix
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doQuery(data) {
      const commit = {
        treatyMode: 'Query',
        accmType: data.accmType,
        treatyNo: data.treatyNo,
        riType: data.riType,
        effDate: data.effDate,
        treatyLvl: data.treatyLvl,
        facVal1: data.facVal1,
        facVal2: data.facVal2,
        facVal3: data.facVal3,
        facVal4: data.facVal4,
        facVal5: data.facVal5,
        facVal6: data.facVal6,
        limType: data.limType,
        accountNoSuffix: data.accountNoSuffix
      }
      sessionStorage.setItem('ttyLim', JSON.stringify(commit))
      this.$store.commit('TREATYLIMIT_COMMIT_KEY', commit)
      this.$router.push({ name: 'treatyLimitDetail' })
    },
    doReview(data) {
      const commitData = {
        treatyMode: 'Review',
        accmType: data.accmType,
        treatyNo: data.treatyNo,
        riType: data.riType,
        effDate: data.effDate,
        treatyLvl: data.treatyLvl,
        facVal1: data.facVal1,
        facVal2: data.facVal2,
        facVal3: data.facVal3,
        facVal4: data.facVal4,
        facVal5: data.facVal5,
        facVal6: data.facVal6,
        limType: data.limType,
        accountNoSuffix: data.accountNoSuffix
      }
      sessionStorage.setItem('ttyLim', JSON.stringify(commitData))
      this.$store.commit('TREATYLIMIT_COMMIT_KEY', commitData)
      this.$router.push({ name: 'treatyLimitDetail' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteTreatyLimit
          const expand = {
            accmType: data.accmType,
            treatyNo: data.treatyNo,
            riType: data.riType,
            effDate: data.effDate,
            treatyLvl: data.treatyLvl,
            facVal1: data.facVal1,
            facVal2: data.facVal2,
            facVal3: data.facVal3,
            facVal4: data.facVal4,
            facVal5: data.facVal5,
            facVal6: data.facVal6,
            limType: data.limType,
            accountNoSuffix: data.accountNoSuffix
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedTreatyLimit.accmType = data.accmType
          this.selectedTreatyLimit.treatyNo = data.treatyNo
          this.selectedTreatyLimit.riType = data.riType
          this.selectedTreatyLimit.effDate = data.effDate
          this.selectedTreatyLimit.treatyLvl = data.treatyLvl
          this.selectedTreatyLimit.facVal1 = data.facVal1
          this.selectedTreatyLimit.facVal2 = data.facVal2
          this.selectedTreatyLimit.facVal3 = data.facVal3
          this.selectedTreatyLimit.facVal4 = data.facVal4
          this.selectedTreatyLimit.facVal5 = data.facVal5
          this.selectedTreatyLimit.facVal6 = data.facVal6
          this.selectedTreatyLimit.limType = data.limType
          this.selectedTreatyLimit.accountNoSuffix = data.accountNoSuffix
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedTreatyLimit) {
        const apiURI = this.menu.deleteTreatyLimit
        if (apiURI) {
          const expand = {
            accmType: this.selectedTreatyLimit.accmType,
            treatyNo: this.selectedTreatyLimit.treatyNo,
            riType: this.selectedTreatyLimit.riType,
            effDate: this.selectedTreatyLimit.effDate,
            treatyLvl: this.selectedTreatyLimit.treatyLvl,
            facVal1: this.selectedTreatyLimit.facVal1,
            facVal2: this.selectedTreatyLimit.facVal2,
            facVal3: this.selectedTreatyLimit.facVal3,
            facVal4: this.selectedTreatyLimit.facVal4,
            facVal5: this.selectedTreatyLimit.facVal5,
            facVal6: this.selectedTreatyLimit.facVal6,
            limType: this.selectedTreatyLimit.limType,
            accountNoSuffix: this.selectedTreatyLimit.accountNoSuffix
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.treatyLimitParam.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
